<template>
	<el-button
		:size="size"
		:type="type"
		:icon="icon"
		:round="round"
		:plain="plain"
		:circle="circle"
		:autofocus="autofocus"
		:loading="loading"
		:disabled="disabled"
		@click="onPress"
	>
		<slot></slot>
	</el-button>
</template>

<script>

export default {
	name: 'LoadingButton',
	props: {
		execute: { type: Function, default: () => new Promise(true) },
		size: { type: String, default: 'medium' },
		type: { type: String, default: 'primary' },
		icon: { type: String, default: 'undefined' },
		round: { type: Boolean, default: false },
		plain: { type: Boolean, default: false },
		circle: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		autofocus: { type: Boolean, default: false }
	},
	data() {
		return {
			loading: false
		};
	},
	methods: {
		onPress() {
			if (!this.loading) {
				this.loading = true;
				this.execute()
					.then(() => { this.loading = false; })
					.catch(() => { this.loading = false; });
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
